/* Pause videos when their section leaves the screen, including editor reloads. */
(() => {
  const videos = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
  }, { threshold: 0.05 }) : null;
  function bind(root) {
    root.querySelectorAll('.lunara-video-frame video').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.addEventListener('play', () => document.querySelectorAll('.lunara-video-frame video').forEach(other => { if (other !== video) other.pause(); }));
      if (observer) observer.observe(video);
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('.lunara-video-frame video').forEach(video => video.pause()); });
})();
